import {I18n} from 'aws-amplify/utils';
import {useParams} from 'react-router-dom';
import {
    Alert,
    Container,
    Text,
    Title,
} from '@mantine/core';

// FNP-1186 placeholder. The real module is FNP-1192, which replaces this file
// with the page and adds the rest of the module inside this directory.
// A record has no identity outside its zone, so this route nests under one and
// reads the zone id from the path.
export const PlaceholderPage = () => {

    const {zoneId} = useParams();

    return (
        <Container p={'xl'}>
            <Title order={2} mb={'md'}>{I18n.get('Records')}</Title>
            <Alert title={I18n.get('Not built yet')}>
                <Text>{I18n.get('This module is registered but not yet implemented. It arrives with FNP-1192.')}</Text>
                <Text mt={'xs'}>{I18n.get('Zone')}: {zoneId}</Text>
            </Alert>
        </Container>
    );
};
